import { Range, Transforms } from 'slate';
import { setFragmentData, extractFragmentData } from '../../utilities/data-transfer/fragment-data.mjs';
import { isRangeWithinVoid } from '../../queries/isRangeWithinVoid.mjs';

/**
 * Use `serializeHTML` and `deserializeHTML` to set and retrieve fragment data
 * for copy paste and drag and drop.
 */
const withFragmentData = (editor, plugins) => {
  editor.setFragmentData = data => setFragmentData(data, {
    editor,
    plugins
  });
  editor.insertData = data => {
    const fragment = extractFragmentData(data, {
      editor,
      plugins
    });
    if (fragment) {
      const location = editor.selection;
      if (Range.isRange(location) && Range.isExpanded(location)) {
        // The default Slate `insertFragment` transform calls
        // `Transforms.delete` on ranges within a `withoutNormalizing`
        // block, which doesn't allow the document to be normalized
        // before inserting the fragment. By manually invoking `Transforms.delete`
        // on the range before inserting the fragment, we allow for normalizers
        // to run before Slate inserts at the point where the selection is
        // collapsed after deletion.
        Transforms.delete(editor, {
          at: location
        });
      }
      Transforms.insertFragment(editor, fragment, {
        voids: true
      });
      if (isRangeWithinVoid(editor, editor.selection)) {
        Transforms.move(editor, {
          distance: 1
        });
      }
    }
  };
  return editor;
};

export { withFragmentData };
